import { Checkbox } from 'antd'
import React, { useState } from 'react'
import { APIFunctions } from '../../lib/apiFunctions'
import { SyncOutlined } from '@ant-design/icons'
import { ComplianceReport } from './types'

export default function WasInDkCheckbox({
    wasindk,
    apiFunctions,
    userId,
    record,
    setDataHasChanged,
    reportMeta,
}: {
    wasindk: boolean
    apiFunctions: APIFunctions
    userId: string
    record
    setDataHasChanged: (nv: boolean) => void
    setChangingVacationsDate?: (date: Date) => void
    reportMeta: ComplianceReport
}) {
    const [checked, setChecked] = useState<boolean>(wasindk)
    const [loading, setLoading] = useState<boolean>(false)

    const LoadingComp = <SyncOutlined style={{ fontSize: 10 }} spin />

    const prefixCls = reportMeta.is_locked ? 'dk-day-checkbox ant-checkbox' : null
    return (
        <>
            <Checkbox
                disabled={loading}
                prefixCls={prefixCls}
                checked={checked}
                onChange={async (newValue) => {
                    if (reportMeta.is_locked) return
                    setLoading(true)
                    if (newValue.target.checked) {
                        await apiFunctions.insertVacationDay(userId, record.date)
                        setChecked(true)
                    } else {
                        await apiFunctions.deleteVacationDay(userId, record.date)
                        setChecked(false)
                    }
                    setLoading(false)
                    setDataHasChanged(true)
                }}
            />
            {' '}
            {loading && LoadingComp}
        </>
    )
}
